import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const table: SxProps<Theme> = {
  width: "100%",
  borderCollapse: "collapse",
};

export const th: SxProps<Theme> = {
  fontSize: "0.78125rem",
  fontWeight: 600,
  color: "text.secondary",
  textAlign: "start",
  pb: 1.25,
  px: 0.5,
};

export const td: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.primary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
});

export const row: SxProps<Theme> = {
  cursor: "pointer",
  transition: "background 0.15s ease",
  "&:hover": {
    bgcolor: "action.hover",
  },
};

export const nameCell: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
};

export const avatar: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: "50%",
  bgcolor: alpha(theme.palette.primary.main, 0.12),
  color: "primary.main",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: "0.8125rem",
  flexShrink: 0,
});

export const phone: SxProps<Theme> = {
  direction: "ltr",
  textAlign: "start",
  color: "text.secondary",
  fontSize: "0.71875rem",
};

export const phoneTd: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.secondary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
  direction: "ltr",
  textAlign: "start",
});

export const amountTd: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.primary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
  fontWeight: 600,
});

export const dateTd: SxProps<Theme> = (theme) => ({
  fontSize: "0.84375rem",
  color: "text.secondary",
  py: 1.625,
  px: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
  verticalAlign: "middle",
});

export const loadingWrap: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  py: 6,
};

export const mobileList: SxProps<Theme> = (theme) => ({
  display: { xs: "flex", md: "none" },
  flexDirection: "column",
  gap: theme.spacing(1.375),
});

export const desktopTable: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
};

export const mobileCard: SxProps<Theme> = (theme) => ({
  p: theme.spacing(1.75),
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  boxShadow: theme.shadows[1],
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.375),
});

export const mobileCardTop: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const mobileCardCustomer: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

export const mobileCardFooter: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  borderTop: `1px dashed ${theme.palette.divider}`,
  pt: 1.25,
});

export const mobileAmount: SxProps<Theme> = {
  fontSize: "0.84375rem",
  fontWeight: 700,
};

export const mobileCurrency: SxProps<Theme> = {
  fontSize: "0.65625rem",
  fontWeight: 500,
  color: "text.secondary",
};

export const actionsCell: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const iconButton: SxProps<Theme> = (theme) => ({
  width: 34,
  height: 34,
  borderRadius: 1.125,
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: "background.paper",
  color: "text.secondary",
  p: 0,
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: alpha(theme.palette.primary.main, 0.08),
    color: "primary.main",
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
});
